/**
 * @description: 时间费明细报表
 * @author: lyr
*/
<template>
    <div class="profit-detail-report">
        <div class="list" v-show="!showBillDetail">
        	<div class="red-tip">注：当天营业数据就只能单个营业日，历史数据支持两个月内的数据查询</div>
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="包厢类型">
                    <el-select v-model="list_form.room_type" filterable  placeholder="请选择包厢类型">
                        <el-option v-for="item in room_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢" :disabled="list_form.shop_id==''">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单类型">
                    <el-select v-model="list_form.order_type" placeholder="请选择订单类型">
                        <el-option v-for="item in order_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">折后总额：{{time_cost_price}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="room_type_name" label="包厢类型"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="bill_no" label="账单号" width="150"></el-table-column>
                <el-table-column prop="start_time" label="开房时间"></el-table-column>
                <el-table-column prop="time_total" label="消费时长"></el-table-column>
                <el-table-column prop="open_type_name" label="订单类型"></el-table-column>
                <el-table-column prop="time_cost_price" label="时间费折后金额"></el-table-column>
                <el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="checkBillDetail(scope.row.bill_no)">账单详情</span>
					</template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 包厢区域选择 -->
        <div class="room-area-pop" ref="room_area_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.area_ids" @change="handleCheckRoomAreaChange">
                    <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 账单详情 -->
        <div class="bill-detail" v-show="showBillDetail">
            <billDetail ref="bill_det" @backBdwPre="showBillDetail=false"></billDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: 'timefee-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                room_type_list: [],
                order_type_list: [{
                    id: '0',
                    name: '全部'
                }, {
                    id: '1',
                    name: '开房套餐'
                }, {
                    id: '2',
                    name: '计时开房'
                }, {
                    id: '3',
                    name: '预买'
                }, {
                    id: '4',
                    name: '包断'
                }],
                checkAllRoomArea: false,
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    area_ids: [],
                    room_id: '0',
                    room_type: '0', // 包厢类型 0全部
                    order_type: '0', // 1开房套餐 2计时开房 3预买 4包断 
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                time_cost_price: 0, // 折后总额
                showBillDetail: false,
            }
        },
        components: {
            "billDetail": billDetail
        },
        computed: {
            room_area_str() {
                if (this.list_form.area_ids.length == 0) {
                    return ''
                }else if(this.list_form.area_ids.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.area_ids.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.list_form.shop_id)
                this.getRoom(this.list_form.shop_id)
                this.getRoomType(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢类型
            getRoomType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getRoomType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_type_list = res.data.response.result.data;
                        _this.room_type_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Report/getTimeCostList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"area_ids": _this.list_form.area_ids,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type, // 包厢类型 0全部
                            "open_type": _this.list_form.order_type, 
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.time_cost_price = res.data.response.result.time_cost_price
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.list_form.area_ids = []
                    this.list_form.room_id = '0'
                    this.list_form.room_type = '0'
                    
                    this.getRoomArea(val)
                    this.getRoom(val)
                    this.getRoomType(val)
                    this.setShopDefaultTime(val)
                }
            },

            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_area_ids = _this.list_form.area_ids
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.list_form.area_ids = c_area_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.area_ids = c_area_ids
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.list_form.area_ids = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.list_form.area_ids.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

        	// 查看账单
            checkBillDetail(bill_no) {
                this.$refs.bill_det.getBdwDetail(bill_no)
                this.showBillDetail = true
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/timeCostExport" +
                    "?start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&area_ids=" + this.list_form.area_ids +
                    "&room_id=" + this.list_form.room_id +
                    "&room_type=" + this.list_form.room_type +
                    "&open_type=" + this.list_form.order_type;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }

    .room-area-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
</style>